interface AppConfig {
  BACKEND_URL: string;
  SUPPORT_EMAIL: string;
  TIPTAP_APP_ID: string;
  TIPTAP_JWT_TOKEN: string;
  TIPTAP_COLLAB_DOC_PREFIX: string;
  TIPTAP_COLLAB_APP_ID: string;
  TIPTAP_COLLAB_TOKEN: string;
  TIPTAP_AI_APP_ID: string;
  TIPTAP_AI_TOKEN: string;
  USE_JWT_TOKEN_API_ENDPOINT: string;
}

declare global {
  interface Window {
    __APP_CONFIG__: AppConfig;
    dataLayer?: Record<string, unknown>[];
  }
}

export const config: AppConfig = window.__APP_CONFIG__;
